import { render, staticRenderFns } from "./ViqArticleDetail.vue?vue&type=template&id=d9563bd6&scoped=true"
import script from "./ViqArticleDetail.vue?vue&type=script&lang=js"
export * from "./ViqArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./ViqArticleDetail.vue?vue&type=style&index=0&id=d9563bd6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9563bd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9563bd6')) {
      api.createRecord('d9563bd6', component.options)
    } else {
      api.reload('d9563bd6', component.options)
    }
    module.hot.accept("./ViqArticleDetail.vue?vue&type=template&id=d9563bd6&scoped=true", function () {
      api.rerender('d9563bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqArticleDetail.vue"
export default component.exports